/* 🤖 this file was generated by script */
export const wiconCancelError = {
  name: 'cancel_error',
  data: `<svg viewBox="0 0 20 20"><path fill="currentColor" fill-rule="evenodd" d="M9 16a1 1 0 011-1 1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1z" clip-rule="evenodd"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 13V3.5M2 2l16 16"/></svg>`,
};
